export const BASE_PARTNER_APPS = '/v1/apps';
export const BASE_PARTNER_APPS_ID = `${BASE_PARTNER_APPS}/:id`;
export const OLD_ADMIN_AUTHORIZATION_URL = `${BASE_PARTNER_APPS}/old-admin/authorization`;
export const HAS_NUVEM_MARKETING_ACCESS_URL = `${BASE_PARTNER_APPS}/has-nuvem-marketing-access`;
